import APIClient from './index';
import _ from 'lodash';

export const getScriptRunConfigs = (params = {}) => {
  return new Promise((resolve, reject) => {
    APIClient.get('AdminScriptConfigurations', { params })
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

export const getScriptRunConfigById = id => {
  return new Promise((resolve, reject) => {
    APIClient.get(`AdminScriptConfigurations/${id}`)
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

export const createScriptRunConfig = data => {
  return new Promise((resolve, reject) => {
    APIClient.post('AdminScriptConfigurations', data)
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

export const updateScriptRunConfig = (id, data) => {
  return new Promise((resolve, reject) => {
    APIClient.put(`AdminScriptConfigurations/${id}`, data)
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

export const deleteScriptRunConfig = id => {
  return new Promise((resolve, reject) => {
    APIClient.delete(`AdminScriptConfigurations/${id}`)
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};
